import { faChevronCircleRight, faHandPointRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useEffect, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCampusBanner } from "../bannerSlice";
import { setCampus } from "../campusSlice";
// import TextCheckbox1 from '../components/SelectButton';
import CityDropdowns from "../components/CityDropdowns";
import Navbar from "../components/Navbar";
import PlayImg from "../components/PlayImg";
import reducer from "../reducer";

const RecruitRow = ({
  id,
  uuid,
  title,
  address_level2,
  address_level3,
  date,
  school,
  category,
}) => (
  <>
    <div className="row">
      <div className="col">
        <a
          href={`#/校园招聘/${id}?u_id=${uuid}`}
          style={{ color: "#202529", textDecoration: "none" }}
        >
          <div className="pull-left">
            <strong>{title}</strong>
          </div>
          <div className="pull-right">
            <span style={{ color: "#007dff" }}>
              详情
              <FontAwesomeIcon icon={faChevronCircleRight} size="lg" fixedWidth />
            </span>
          </div>
          <br />
          <span className="text-muted">
            举办地点:
            {`${address_level2}-${address_level3}`}
          </span>
          <br />
          <span className="text-muted">
            开始时间:
            {date}
          </span>
          <br />
          <span>
            {school}({category})
          </span>
        </a>
      </div>
    </div>
    <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
  </>
);

RecruitRow.propTypes = {
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  address_level2: PropTypes.string.isRequired,
  address_level3: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  school: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
};

export default function List() {
  const [state, dispatch] = useReducer(reducer, {
    BANNER: useSelector((state) => state.banner.campus_list),
    CAMPUS: useSelector((state) => state.campus.list),
    CATEGORY: "",
  });
  const reduxDispatch = useDispatch();
  // const [flag, setFlag] = React.useState(true);
  const [types, setTypes] = React.useState({});
  const [city, setCity] = React.useState("");
  const el1 = React.useRef(null);
  const el2 = React.useRef(null);
  // const [category1, setCategory1] = React.useState(true);
  // const [category2, setCategory2] = React.useState(true);
  // const [screen, setScreen] = React.useState('');
  const search = (param) => {
    const url = [
      "/api/bulletin",
      "?option=campus-by-address_level2-category-keyword",
      `&address_level2=${param.city}`,
      `&category=${param.category}`,
      "&keyword=",
    ];
    fetch(url.join(""))
      .then((response) => response.json())
      .then((data) => {
        dispatch({ type: "set", payload: { key: "CAMPUS", value: data } });
        reduxDispatch(setCampus({ list: data }));
      });
  };
  const _onCheckboxChange = (val) => {
    if (val === "宣讲会") {
      if (el1.current.getAttribute("class").indexOf("text-muted") >= 0) {
        el1.current.className = "text-success bg-light";
        el2.current.className = "text-muted";
      } else {
        el1.current.className = "text-muted";
      }
    }
    if (val === "双选会") {
      if (el2.current.getAttribute("class").indexOf("text-muted") >= 0) {
        el2.current.className = "text-success bg-light";
        el1.current.className = "text-muted";
      } else {
        el2.current.className = "text-muted";
      }
    }
    search({
      city,
      keyword: "",
      category: val,
      ...types,
      // [name]: checked,
    });
    setTypes((p) => ({
      ...p,
      // [name]: checked,
    }));
  };
  const handleChange = (val) => {
    search({
      city: val,
      category: "",
      keyword: "",
      ...types,
    });
    setCity(val);
  };

  useEffect(() => {
    document.title = "校园招聘";
  }, []);

  useEffect(() => {
    if (0 === state.CAMPUS.length) {
      const url = [
        "/api/bulletin",
        "?option=campus-by-address_level2-category-keyword",
        "&address_level2=",
        "&category=",
        "&keyword=",
      ];
      fetch(url.join(""))
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          dispatch({
            type: "set",
            payload: { key: "CAMPUS", value: state.CAMPUS.concat(data) },
          });
          reduxDispatch(setCampus({ list: state.CAMPUS.concat(data) }));
        });
    }
  }, []);

  useEffect(() => {
    if (0 === state.BANNER.length) {
      fetch("/api/bulletin?option=banner-by-category&category=小程序-校园招聘")
        .then((response) => response.json())
        .then((data) => {
          dispatch({ type: "set", payload: { key: "BANNER", value: data } });
          reduxDispatch(setCampusBanner({ list: data }));
        });
    }
  }, []);

  return (
    <>
      <div className="container-fluid">
        {/* <Title category="校园招聘" /> */}
        {0 < state.BANNER.length && <PlayImg list={state.BANNER} />}
        <div className="row pb-2 pt-2" style={{ backgroundColor: "#f5f5f5" }}>
          <div className="col">
            <input
              type="text"
              className="w-100 border-0 text-center rounded-pill"
              placeholder="按照企业/学校名称查询"
              onClick={() => {
                location.href = "#校园招聘/查询/";
              }}
              style={{ outline: 0, height: 35 }}
            />
          </div>
        </div>
        <div className="card border-0 user-radius mt-1 shadow">
          <a href="#招聘会" style={{ textDecoration: "none" }}>
            <div className="card-body">
              <span className="pull-left">
                <FontAwesomeIcon icon={faHandPointRight} size="2x" fixedWidth />
              </span>
              <h6 className="pull-left pt-1 pb-2">
                <strong>&nbsp;线上校园招聘会</strong>
              </h6>
              <span className="pull-right pt-1 pb-2">
                <FontAwesomeIcon icon={faChevronCircleRight} size="lg" fixedWidth />
              </span>
            </div>
          </a>
        </div>
        <div className="card border-0 user-radius mt-2 shadow">
          <div className="card-body">
            <div className="row mb-3" style={{ fontSize: 14 }}>
              <div className="col">
                <CityDropdowns handleChange={handleChange} />
              </div>
              <div className="col">
                <div className="pull-right text-muted">
                  <span
                    ref={el1}
                    className="text-muted"
                    onClick={() => _onCheckboxChange("宣讲会")}
                  >
                    宣讲会
                  </span>
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span
                    ref={el2}
                    className="text-muted"
                    onClick={() => _onCheckboxChange("双选会")}
                  >
                    双选会
                  </span>
                  {/* <TextCheckbox1 name="宣讲会" onChange={_onCheckboxChange}>
                      宣讲会
                    </TextCheckbox1>
                    <TextCheckbox1 name="双选会" onChange={_onCheckboxChange}>
                      双选会
                    </TextCheckbox1> */}
                </div>
              </div>
            </div>
            <div>
              {0 < state.CAMPUS.length &&
                state.CAMPUS.map((item) => <RecruitRow key={item.id} {...item} />)}
            </div>
            {/* {flag === true ? (
                <button id="load" className="btn btn-block mx-auto" onClick={load}>
                  点击加载更多
                </button>
              ) : (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )} */}
          </div>
        </div>
      </div>
      <Navbar category="校园招聘" />
    </>
  );
}
